module.exports = __webpack_public_path__ + "img/12_81.6eacdc4d.png";